import { create } from 'zustand';

export interface BreadcrumbItem {
  label: string;
  path?: string;
}

interface BreadcrumbState {
  items: BreadcrumbItem[];
  set: (items: BreadcrumbItem[]) => void;
  clear: () => void;
}

export const useBreadcrumbStore = create<BreadcrumbState>((set) => ({
  items: [],
  set: (items) => set({ items }),
  clear: () => set({ items: [] }),
}));
